import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData, API_URL } from '../../Api';

export default function TaroffOrderStateChanges(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-carrier-id': filterQCarrierId,
            'q-shop-id': filterQShopId,
            'q-insert-time-from': filterQInsertTimeFrom,
            'q-insert-time-to': filterQInsertTimeTo,
            'q-old-state-id': filterQOldStateId,
            'q-new-state-id': filterQNewStateId,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-order-state-changes/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const handlecomp2 = () => {
        applyFilters();
    };
    const [formQCarrierIdOptions, setFormQCarrierIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes/select-data/q-carrier-id').then(
            (response) => {
                setFormQCarrierIdOptions(response.data);
            }
        );
    }, []);
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQOldStateIdOptions, setFormQOldStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes/select-data/q-old-state-id').then(
            (response) => {
                setFormQOldStateIdOptions(response.data);
            }
        );
    }, []);
    const [formQNewStateIdOptions, setFormQNewStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes/select-data/q-new-state-id').then(
            (response) => {
                setFormQNewStateIdOptions(response.data);
            }
        );
    }, []);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQCarrierId('');
        setFilterQShopId('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQOldStateId('');
        setFilterQNewStateId('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQCarrierId && (newSearchParams['q-carrier-id'] = filterQCarrierId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQOldStateId && (newSearchParams['q-old-state-id'] = filterQOldStateId);
        filterQNewStateId && (newSearchParams['q-new-state-id'] = filterQNewStateId);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQCarrierId, setFilterQCarrierId] = useState(allProps['q-carrier-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQOldStateId, setFilterQOldStateId] = useState(allProps['q-old-state-id'] || '');
    const [filterQNewStateId, setFilterQNewStateId] = useState(allProps['q-new-state-id'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes/table-data', {
            size: tableSize,
            page: tablePage,
            q_carrier_id: filterQCarrierId,
            q_shop_id: filterQShopId,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_old_state_id: filterQOldStateId,
            q_new_state_id: filterQNewStateId,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Title>تغییر وضعیت های سفارشات</Title>
            <Row>
                <RightComponents>
                    <Title>تغییر وضعیت های سفارشات</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        اکسل
                    </Button>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'حامل'}
                    options={formQCarrierIdOptions}
                    value={filterQCarrierId}
                    onChange={setFilterQCarrierId}
                />
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQOldStateIdOptions}
                    value={filterQOldStateId}
                    onChange={setFilterQOldStateId}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQNewStateIdOptions}
                    value={filterQNewStateId}
                    onChange={setFilterQNewStateId}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>سفارش</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>از وضعیت</TableColumn>
                        <TableColumn mobile={false}>به وضعیت</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_order_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_order_id_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_order_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_old_state_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_new_state_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
